import _ from 'lodash';
import c from 'common/constants/flux-events';
import findCacheState from 'utils/find-cache-state';
const initialState = {
    isLoading: false,
    currentView: {
        entityType: 'implicitLayer',
        entityId: void 0,
    },
};

const parseRoute = path => /^\/campaigns\/\d+\/setup\/ads\/?$/.test(path);

export default function reducer(state = {}, action) {
    switch (action.type) {
        case c.OVERVIEW_ADS__AD_DRAFT_NEW__INIT_STATE: {
            const { campaignId } = action.payload;

            return findCacheState(campaignId, state, initialState);
        }
        // case '@@router/LOCATION_CHANGE': {
        //     const isOverviewAdsUrl = parseRoute(action.path);
        //     if (!isOverviewAdsUrl) {
        //         return state;
        //     }
        //     return {
        //         ...state,
        //         filterUrl: action.path
        //     };
        // }

        case c.OVERVIEW_ADS__AD_DRAFT_NEW__SHOW_GEO_ENTITY_IN_MAP: {
            const currentView = {
                entityType: action.payload.entityType,
                entityId: action.payload.entityId,
            };
            const o = {
                ...state,
                currentView,
            };
            return o;
        }

        case c.OVERVIEW_ADS__AD_DRAFT_NEW__REFRESH_GEO_ENTITY_IN_MAP: {
            const date = new Date();
            const dateStamp = date.toISOString();
            const o = {
                ...state,
                eTag: dateStamp,
            };
            return o;
        }
        default:
            return state;
    }
}
